import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b19e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-detail" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = {
  key: 0,
  class: "action"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "btns" }
const _hoisted_6 = { class: "selected-num" }
const _hoisted_7 = { class: "orange" }
const _hoisted_8 = { class: "dialogvisible-content" }
const _hoisted_9 = { class: "content-table" }
const _hoisted_10 = { class: "total-info" }
const _hoisted_11 = { class: "order-type" }
const _hoisted_12 = { class: "orange" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-th" }, [
  /*#__PURE__*/_createElementVNode("span", null, "姓名/账户"),
  /*#__PURE__*/_createElementVNode("span", null, "状态/委托数量")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-info" }, "注：未成交部分将全部撤单", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FargoTable = _resolveComponent("FargoTable")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name,
                class: _normalizeClass(_ctx.activeIndex === index ? 'btn-active' : 'btn-update'),
                onClick: ($event: any) => (_ctx.changeIndex(index))
              }, _toDisplayString(item.name), 11, _hoisted_4))
            }), 128)),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "btn-cancel",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelSelect && _ctx.cancelSelect(...args)))
              }, "取消"),
              _createElementVNode("div", {
                class: "btn-confirm",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmSelect && _ctx.confirmSelect(...args)))
              }, "确定")
            ], 512), [
              [_vShow, _ctx.activeIndex === 0 || _ctx.activeIndex === 1]
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createTextVNode(" 已选择 "),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.orderQty), 1),
        _createTextVNode(" 项 ")
      ], 512), [
        [_vShow, _ctx.showAction]
      ]),
      _createVNode(_component_FargoTable, {
        list: _ctx.tableData,
        "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tableData) = $event)),
        "t-header-list": _ctx.tHeaderList,
        stripe: false,
        onChange: _ctx.change,
        onChangeSelect: _ctx.changeSelect,
        onCheckAll: _ctx.checkAll,
        toggleIndex: _ctx.activeIndex
      }, null, 8, ["list", "t-header-list", "onChange", "onChangeSelect", "onCheckAll", "toggleIndex"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisibleFlag,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisibleFlag) = $event)),
      title: "撤单确认",
      width: "500px",
      "destroy-on-close": "",
      center: "",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "content-close",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisibleFlag = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "content-confirm",
          Select: "",
          onClick: _ctx.confirm,
          loading: _ctx.confirmLoadinSelectg,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" 以下每个账户将以" + _toDisplayString(_ctx.orderInfoList.entrustProp.includes('MO')
                ? '市价'
                : _ctx.orderInfoList.entrustPrice), 1),
              _createElementVNode("span", {
                class: _normalizeClass(
                _ctx.orderInfoList.entrustBs === _ctx.EntrustBs.BID ? 'orange' : 'blue'
              )
              }, _toDisplayString(_ctx.orderInfoList.entrustBs === _ctx.EntrustBs.BID ? '买入' : '卖出'), 3),
              _createTextVNode(_toDisplayString(_ctx.orderInfoList.stockName) + "(" + _toDisplayString(_ctx.orderInfoList.stockCode) + "." + _toDisplayString(_ctx.orderInfoList.exchangeType) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createTextVNode(" 订单类型："),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.ENTRUSTPROPMAP[_ctx.orderInfoList.entrustProp]), 1)
            ]),
            _hoisted_13,
            _createVNode(_component_el_scrollbar, { class: "scroll-wrapper" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForm, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "table-th table-tb",
                    key: index
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.nameCn) + " / " + _toDisplayString(item.fundAccount), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.STATES[item.entrustStatus]) + "/" + _toDisplayString(_ctx.numFormat(item.entrustAmount, 0)), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}